import React from "react";
import Layout from "~/components/ui/Layout";
import Container from "~/components/ui/Container";
import PrimaryButton from "~/components/ui/PrimaryButton";
import CheckIcon from "~/components/Icons/CheckIcon";
import classNames from "classnames";

function Circle({ status }) {
  if (status === "complete") {
    return (
      <div className="w-10 h-10 rounded-full bg-blue flex items-center justify-center">
        <CheckIcon stroke="#fff" className="h-6" />{" "}
      </div>
    );
  }
  if (status === "inprogress") {
    return (
      <div className="w-10 h-10 rounded-full border-2 border-blue flex items-center justify-center">
        <div className="w-3 h-3 rounded-full bg-blue"></div>
      </div>
    );
  }
  if (status === "incomplete") {
    return (
      <div className="w-10 h-10 rounded-full border-2 border-gray-400 flex items-center justify-center">
        <CheckIcon stroke="#fff" className="h-8" />{" "}
      </div>
    );
  }
  return null;
}

function Step({ status, title, text, firstStep, lastStep }) {
  return (
    <div className="flex items-center">
      <div className="flex flex-col items-center h-20 md:h-28">
        {/* <div className="absolute border border-gray-400 h-full left-1/2" /> */}
        <div
          className={classNames("flex-1 border-gray-400", {
            border: !firstStep,
          })}
        ></div>
        <Circle status={status} />
        <div
          className={classNames("flex-1 border-gray-400", {
            border: !lastStep,
          })}
        ></div>
      </div>
      <div className="flex-1 ml-6 h-20 md:h-28 flex flex-col justify-center">
        <h2 className="font-bold text-md md:text-xl">{title}</h2>
        <p className="text-sm md:text-lg">{text}</p>
      </div>
    </div>
  );
}

export default function GiveAwayStatus() {
  return (
    <Layout>
      <Container
        className="py-2 md:py-10 px-2 w-full md:w-2/5 min-h-screen"
        backgroundClassName="bg-white"
      >
        <div className="mb-10 text-center">
          <h2 className="uppercase font-bold text-4xl md:text-5xl my-4">
            Giveaway Status
          </h2>
        </div>
        <div>
          {/* <p className="text-lg md:text-xl text-red mb-12">
            T-shirt production got delayed due to some technical issues. We are
            targeting to ship swag by Sep 30st. You can check this page for the
            status.
          </p> */}
          {/* <p className="text-lg md:text-xl">
            We are giving away lot of cool swag in this edition of the
            conference. Congrats if you won the giveaway or swag challenge.
          </p>
          <p className="text-lg md:text-xl"></p>
          <p className="text-lg md:text-xl mt-4 mb-10">
            Please note that it will take us 2 months for us to ship swag. We
            are targeting to ship swag to all the winners by Sep 15th, 2022. You
            can check this page for the status.
          </p> */}
        </div>
        <div>
          <Step
            status="complete"
            title="Conducting giveaway/swag challenges"
            text="We are targeting to finish swag challenges and collect T-shirt size info from winners by June 15th"
            firstStep={true}
          />
          <Step
            status="complete"
            title="Place bulk swag order"
            text="We are targeting to complete the swag print test and place bulk order by July 31th"
          />
          <Step
            status="complete"
            title="T-shirt Production"
            text="We are expecting our vendor to produce and deliver T-shirts to us by Aug 31st."
          />
          <Step
            status="inprogress"
            title="Shipping"
            text="We started shipping swag"
          />
          <Step
            status="incomplete"
            title="Complete shipping swag"
            text="We are targeting to finish shipping swag to all giveaway winners by Oct 15th, 2022"
            lastStep={true}
          />

          <div className="mt-10">
            <h2 className="font-bold">Disclaimers</h2>
            <p>
              * Currently, we can ship swag only within India because of
              logistic limitations.
            </p>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
